export default function ProgressBar({ value = 0, label, showPercent = true }) {
  const v = Math.min(100, Math.max(0, Number(value) || 0));
  return (
    <div style={{ width: "100%" }}>
      {(label || showPercent) && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "6px",
            fontSize: "12px",
            color: "var(--text-secondary)",
          }}
        >
          <span>{label}</span>
          {showPercent ? <span>{Math.round(v)}%</span> : null}
        </div>
      )}
      <div
        style={{
          height: "6px",
          borderRadius: "999px",
          background: "var(--border)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${v}%`,
            borderRadius: "999px",
            background: "var(--accent)",
            transition: "width 280ms ease",
          }}
        />
      </div>
    </div>
  );
}
